module.exports = __webpack_public_path__ + "static/media/GAOFEN 5.84d449bc.czml";